import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import JanusSuperUser from '../../helpers/janus-superuser';
import Room from '../RoomItem';
import Visualizer from '../AudioVisualizer';

import { Container, RoomsList } from './styles';

/** Config - these should all come from local storage */

const { cookie } = document;

const output = {};

cookie.split(/\s*;\s*/).forEach((pair) => {
  pair = pair.split(/\s*=\s*/);
  output[pair[0]] = pair.splice(1).join('=');
});

const lanesFromCookies = output?.streamer_lanes ? JSON.parse(output?.streamer_lanes) : [];
const mediaFromCookies = output?.streamer_media ? JSON.parse(output?.streamer_media) : [];

const Lanes = lanesFromCookies.map((item, i) => ({
  ...item,
  audioVideoUrl: mediaFromCookies.mediaServerUrl,
  mediaRoomID: `50${item.sequence}0`,
  mediaToken: mediaFromCookies.mediaToken,
}));

// const lanesFromCookies = JSON.parse('[{"laneID":"d2080adb-3a90-4a09-0a10-08d86584659b","lane":"DOMESTIC LANE","sequence":1,"audioVideoUrl":"wss://simcast-1.npauctions.com/npjanus","mediaRoomID":"5010","mediaToken":"1LBU2O18M72"},{"laneID":"55403d5d-f56e-4ac0-ac9a-08d865846928","lane":"METRIC SPORT / CRUISER LANE","sequence":2,"audioVideoUrl":"wss://simcast-1.npauctions.com/npjanus","mediaRoomID":"5020","mediaToken":"1LBU2O18M72"},{"laneID":"86f6588b-9447-4f53-8574-08d865846896","lane":"OFF-ROAD / BOAT / RV LANE","sequence":3,"audioVideoUrl":"wss://simcast-1.npauctions.com/npjanus","mediaRoomID":"5030","mediaToken":"1LBU2O18M72"}]');
const roomsArray = Lanes.map((item) => ({
  roomId: parseInt(item.mediaRoomID),
  laneId: item.laneID,
  mediaToken: item.mediaToken,
  laneName: item.lane,
  audioVideoUrl: item.audioVideoUrl,
  status: {
    preAuctionAudio: false,
    pauseAudio: false,
    postAuctionAudio: false,
    speaking: false,
  },
}));

const server = mediaFromCookies?.audioVideoUrl || null;
const token = roomsArray[0]?.mediaToken || null;

const iceServers = [
  {
    urls: mediaFromCookies?.mediaStunUrl,
  },
  {
    urls: mediaFromCookies?.mediaTurnUrls,
    credential: mediaFromCookies?.mediaTurnPassword,
    username: mediaFromCookies?.mediaTurnAccount,
  },
];

// const iceServers = [
//   {
//     urls: 'stun:stun.l.google.com:19302',
//   },
//   // NOTE: Your TURN servers here!
//   {
//     urls: ['turn:tnstage01.npauctions.com:53', 'turn:tnstage01.npauctions.com:443?transport=tcp'],
//     credential: 'nppasswd',
//     username: 'npuser',
//   },
// ];

/** End config */
const Rooms = ({ setError, setMessage }) => {
  const [lanes, setLanes] = useState(roomsArray);
  const [isConnected, setIsConnected] = useState(false);
  const [mixers, setMixers] = useState(null);
  const [allLanesState, setAllLanesState] = useState(false);
  const [recoveringFromError, setRecoveringFromError] = useState(false);

  const janus = new JanusSuperUser(roomsArray);

  /** Returns the correct janus function based on the action and toggle value */
  const JanusToggle = (action, state) => {
    if (action === 'speaking') {
      return state ? janus.joinRoom : janus.leaveRoom;
    }

    return state ? janus.playAudioFile : janus.stopAudioFile;
  };

  /** Turns mic or music on/off */
  /** Takes a room ID and one of defaultMusicPlaying, goodbyeMusicPlaying, speaking */
  const toggle = (roomId, action, start = true) => {
    const newArray = lanes.filter((item) => item.roomId === roomId);
    const newObj = newArray[0];
    const { status } = newObj;

    Object.keys(status).forEach(async (item) => {
      if (action === item) {
        newObj.status[item] = !newObj.status[item];
        if (start) {
          await JanusToggle(item, newObj.status[item])(roomId, mixers[roomId], action).catch((error) => setError(error));
        }
      }
      // newObj.status[item] = false;
      // JanusToggle(item, newObj.status[item])(roomId, mixers[roomId]);
    });

    const updatedLanes = lanes.map((item) => {
      if (item.roomId === roomId) {
        return newObj;
      }
      return item;
    });

    setLanes(updatedLanes);
  };

  /** Switches all rooms on/off */
  const toggleAllRooms = (id, action) => {
    setAllLanesState(!allLanesState);
    lanes.filter((item) => item.status[action] === allLanesState).map((item) => toggle(item.roomId, action, true));
  };

  /** Every 5 seconds check the status of the default music */
  useEffect(() => {
    const actions = ['preAuctionAudio', 'pauseAudio', 'postAuctionAudio'];


    if (isConnected && mixers) {
      let interval = null;
      interval = setInterval(() => {
        Object.keys(lanes).forEach(async (lane) => {
          try {
            const preAuctionAudioStatus = await janus.checkAudioStatus(lanes[lane].roomId, mixers[lanes[lane].roomId], '_var_www_html_NPAPreAuction.opus');
            const pauseAuctionAudioStatus = await janus.checkAudioStatus(lanes[lane].roomId, mixers[lanes[lane].roomId], '_var_www_html_NPAPauseAuction.opus');
            const postAuctionAudioStatus = await janus.checkAudioStatus(lanes[lane].roomId, mixers[lanes[lane].roomId], '_var_www_html_NPAPostAuction.opus');
            setError(null);

            if (recoveringFromError) {
              if (lanes[lane].status.speaking) {
                toggle(lanes[lane].roomId, 'speaking');
                toggle(lanes[lane].roomId, 'speaking');
              }
            }

            setRecoveringFromError(false);

            if (preAuctionAudioStatus !== lanes[lane].status.preAuctionAudio) {
              toggle(lanes[lane].roomId, 'preAuctionAudio', false);
            }

            if (pauseAuctionAudioStatus !== lanes[lane].status.pauseAudio) {
              toggle(lanes[lane].roomId, 'pauseAudio', false);
            }

            if (postAuctionAudioStatus !== lanes[lane].status.postAuctionAudio) {
              toggle(lanes[lane].roomId, 'postAuctionAudio', false);
            }

            setIsConnected(true);
          } catch (error) {

            actions.map((item) => {
              if (lanes[lane].status[item]) {
                toggle(lanes[lane].roomId, item, false);
              }
            });
            setRecoveringFromError(true);
            setError(error);
            if (error.includes('Unauthorized request (wrong or missing secret/token)')) {
              setIsConnected(false);
              clearInterval(interval);
            }
          }
        });
      }, 3000);
    }
  }, [isConnected, mixers, recoveringFromError]);

  useEffect(() => {
    if (lanes.length > 0) {
      janus.initialize(server, token, iceServers)
        .then((response) => {
          setIsConnected(true);
          setMixers(response);
          /** Auto start the mic mixer for the lane we entered from */
          //
        })
        .catch((error) => {
          setIsConnected(false);
          setError(error);
        });
    }
  }, []);

  useEffect(() => {
    if (mixers && mixers[mediaFromCookies.mediaRoomID]) {
      toggle(parseInt(mediaFromCookies.mediaRoomID), 'speaking');
    }
  }, [mixers]);

  useEffect(() => {
    const audioActions = ['preAuctionAudioFile', 'pauseAuctionAudioFile', 'speaking'];

    for (let i = 0; i < audioActions.length; i++) {
      const action = audioActions[i];
      const state = lanes.filter((item) => item.status[action] === true).length === lanes.length; i++;
      //setAllLanesState(state);
      if (state) break;
    }
  }, [lanes]);

  return (
    <Container>

      {lanes.length <= 0
        && <p style={{ textAlign: 'center' }}>No Lanes found.<br />Try closing browser and login to Simulcast again.</p>}

      {lanes.length > 0 && (
      <RoomsList>

        {/** Iterate thought all lanes, pass the room object and toggle function to Room component */}
        {lanes.map((item, i) => (
          <Room
            key={i}
            roomObject={item}
            toggle={toggle}
            isConnected={isConnected}
          />
        ))}

        {/** Control for ALL LANES */}
        <Room
          key={1000}
          allRooms
          roomObject={{
            roomId: 'ALL LANES',
            laneId: 'ALL LANES',
            laneName: 'ALL',
            status: {
              preAuctionAudio: lanes.filter((item) => item.status.preAuctionAudio === true).length === lanes.length,
              pauseAudio: lanes.filter((item) => item.status.pauseAudio === true).length === lanes.length,
              postAuctionAudio: lanes.filter((item) => item.status.postAuctionAudio === true).length === lanes.length,
              speaking: lanes.filter((item) => item.status.speaking === true).length === lanes.length,
            },
          }}
          checkDefaultMusic={janus.checkDefaultMusic}
          toggle={toggleAllRooms}
          isConnected={isConnected}
        />
      </RoomsList>
      )}
      {/* <Visualizer liveMic={micLive.filter((item) => item === true).length > 0} /> */}
    </Container>
  );
};

Rooms.propTypes = {
  setError: PropTypes.func.isRequired,
};

export default Rooms;
